import * as React from "react";
import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {Checkbox} from "office-ui-fabric-react";
import * as microsoftTeams from "@microsoft/teams-js";
import {FilingLocation} from "../models";

export interface IIndividualCheckboxState extends ITeamsBaseComponentState {
    CheckboxSelected: boolean;
}

export interface IIndividualCheckboxProps {
    SelectFolder: (value: boolean, location: FilingLocation) => void;
    RenderedFolder: FilingLocation;
    SelectedFolder: FilingLocation;
    SelectedCheckboxValue: boolean;
    DefaultSelectedChannel: string;
    HideCheckoutButton: (value: boolean, location: FilingLocation) => void;
    HasAnyFolderBeenExpanded: boolean;
}

export class IndividualCheckbox extends TeamsBaseComponent<IIndividualCheckboxProps, IIndividualCheckboxState> {
    constructor(props: IIndividualCheckboxProps) {
        super(props);
        this.state = {
            theme: null,
            CheckboxSelected: false,
        };
    }

    public async componentWillMount(): Promise<void> {
        microsoftTeams.initialize();
    }

    componentDidMount() {
        if (
            this.props.RenderedFolder.Metadata["ChannelId"] == this.props.DefaultSelectedChannel &&
            this.props.RenderedFolder.Metadata["IsChannelFolder"] == "true"
        ) {
            this.setState({CheckboxSelected: true});
            this.folderSelected(true);
        } else if (this.props.RenderedFolder.Metadata["IsChannelFolder"] == undefined) {
            this.props.HideCheckoutButton(false, null);
        }
    }

    componentDidUpdate(
        prevProps: Readonly<IIndividualCheckboxProps>,
        _prevState: Readonly<IIndividualCheckboxState>
    ): void {
        if (this.props.HasAnyFolderBeenExpanded && this.props != prevProps) {
            // Whenever we expand the folder, all of the checkbox values should be false
            this.setState({CheckboxSelected: false});
        }

        if (this.props.SelectedFolder == this.props.RenderedFolder) {
            if (this.state.CheckboxSelected != this.props.SelectedCheckboxValue) {
                this.setState({CheckboxSelected: this.props.SelectedCheckboxValue});
            }
        } else if (this.props.SelectedFolder != null) {
            // don't reset the default value when the panel initially opens
            if (this.state.CheckboxSelected == true) {
                this.setState({CheckboxSelected: false});
            }
        }
    }

    folderSelected = (val: boolean) => {
        this.props.SelectFolder(val, this.props.RenderedFolder);

        this.setState({CheckboxSelected: val});
    };

    public render() {
        return <Checkbox checked={this.state.CheckboxSelected} onChange={(_, val) => this.folderSelected(val)} />;
    }
}

export default IndividualCheckbox;
